import { AuthGrantManager } from '@metro-membership/util';

export class FrontendAuthGrantManager extends AuthGrantManager {
	protected async resolveEntityTree(level: 'node' | 'institute'): Promise<boolean> {
		return false;
	}
}
